import React, { forwardRef, useRef, } from 'react';
import CytoscapeComponent from 'react-cytoscapejs';
import { ErrorBoundary } from 'react-error-boundary';
const GraphView = forwardRef(({ ...props }, ref) => {
    const cy = useRef();
    // This fixes the type issue with the Cytoscape react library that doesn't actually except "refs". So we handle that here,
    // and make it follow react conventions instead of doing it's own thing.
    // istanbul ignore next (this is tested through other tests, but not the negative case)
    const setRef = (core) => {
        ref.current = core;
        cy.current = core;
    };
    return (React.createElement(ErrorBoundary, { fallback: React.createElement("div", null, "Error"), onError: () => { } },
        React.createElement(CytoscapeComponent, { cy: setRef, ...props }),
        ";"));
});
export default GraphView;
